import React, { useEffect, useId, useRef } from 'react';
import './ModalFaturaGerada.css';

export default function ModalFaturaGerada({ linkPagamento, onFechar }) {
  const dialogRef = useRef(null);
  const mensagemId = useId();

  useEffect(() => {
    if (!linkPagamento) return undefined;
    const dialog = dialogRef.current;
    dialog.showModal();
    return () => {
      if (dialog.open) dialog.close();
    };
  }, [linkPagamento]);

  if (!linkPagamento) return null;

  return (
    <dialog
      ref={dialogRef}
      className="panel-compact-dialog modal-fatura-gerada"
      role="alertdialog"
      aria-modal="true"
      aria-labelledby={mensagemId}
      onCancel={onFechar}
    >
      <p id={mensagemId}>Fatura gerada com sucesso.</p>
      <a
        href={linkPagamento}
        target="_blank"
        rel="noopener noreferrer"
        className="routine-btn routine-btn--primary"
        onClick={onFechar}
      >
        OK
      </a>
    </dialog>
  );
}
